function Backdrop({ onClick }) {
  return <div className="fixed inset-0 bg-black bg-opacity-30 z-10" onClick={onClick}></div>
}

export default Backdrop
